import formEditorConstants from './constants';

const formEditorActions = {
  formEditorInit: (formId, token) => ({
    type: formEditorConstants.INITIALIZE_FORM_EDITOR,
    payload: {
      formId,
      token
    }
  }),
  formEditorInitSuccess: (form, teamName) => ({
    type: formEditorConstants.INITIALIZE_FORM_EDITOR_SUCCESS,
    payload: {
      form,
      teamName
    }
  }),
  formEditorInitError: () => ({
    type: formEditorConstants.INITIALIZE_FORM_EDITOR_ERROR
  }),
  formSave: (republish, token) => ({
    type: formEditorConstants.FORM_SAVE,
    payload: {
      republish,
      token
    }
  }),
  formSaveSuccess: () => ({
    type: formEditorConstants.FORM_SAVE_SUCCESS
  }),
  formSaveError: () => ({
    type: formEditorConstants.FORM_SAVE_ERROR
  }),
  formDelete: token => ({
    type: formEditorConstants.FORM_DELETE,
    payload: {
      token
    }
  }),
  formDeleteSuccess: () => ({
    type: formEditorConstants.FORM_DELETE_SUCCESS
  }),
  formDeleteError: () => ({
    type: formEditorConstants.FORM_DELETE_ERROR
  }),
  formPublish: token => ({
    type: formEditorConstants.FORM_PUBLISH,
    payload: {
      token
    }
  }),
  formPublishSuccess: () => ({
    type: formEditorConstants.FORM_PUBLISH_SUCCESS
  }),
  formPublishError: () => ({
    type: formEditorConstants.FORM_PUBLISH_ERROR
  }),
  formElementChange: target => ({
    type: formEditorConstants.FORM_ELEMENT_CHANGE,
    payload: {
      target
    }
  }),
  formElementTypeChange: type => ({
    type: formEditorConstants.FORM_ELEMENT_TYPE_CHANGE,
    payload: {
      type
    }
  }),
  formEditorModeChange: mode => ({
    type: formEditorConstants.FORM_EDITOR_MODE_CHANGE,
    payload: {
      mode
    }
  }),
  formDetailsChange: target => ({
    type: formEditorConstants.FORM_DETAILS_CHANGE,
    payload: {
      target
    }
  }),
  formElementSelected: selectedElement => ({
    type: formEditorConstants.FORM_ELEMENT_SELECTED,
    payload: {
      selectedElement
    }
  }),
  formElementMoveUp: id => ({
    type: formEditorConstants.FORM_ELEMENT_MOVE_UP,
    payload: {
      id
    }
  }),
  formElementMoveDown: id => ({
    type: formEditorConstants.FORM_ELEMENT_MOVE_DOWN,
    payload: {
      id
    }
  }),
  formElementRemove: id => ({
    type: formEditorConstants.FORM_ELEMENT_REMOVE,
    payload: {
      id
    }
  }),
  formPreviewChange: form => ({
    type: formEditorConstants.FORM_PREVIEW_CHANGE,
    payload: {
      formData: form.formData
    }
  }),
  formDetailsAddElement: newElementType => ({
    type: formEditorConstants.FORM_DETAILS_ADD_ELEMENT,
    payload: {
      newElementType
    }
  }),
  formElementRequiredChange: id => ({
    type: formEditorConstants.FORM_ELEMENT_REQUIRED_CHANGE,
    payload: {
      id
    }
  }),
  formElementOptionsChange: optionsText => ({
    type: formEditorConstants.FORM_ELEMENT_OPTIONS_CHANGE,
    payload: {
      optionsText
    }
  }),
  formUnload: () => ({
    type: formEditorConstants.FORM_UNLOAD
  }),
  formPrivacyChange: privacy => ({
    type: formEditorConstants.FORM_PRIVACY_CHANGE,
    payload: {
      privacy
    }
  }),
  formPrivacyChangeSuccess: privacy => ({
    type: formEditorConstants.FORM_PRIVACY_CHANGE_SUCCESS,
    payload: {
      privacy
    }
  }),
  formPrivacyChangeError: () => ({
    type: formEditorConstants.FORM_PRIVACY_CHANGE_ERROR
  }),
  formTaskDeadlineChange: deadline => ({
    type: formEditorConstants.FORM_TASK_DEADLINE_CHANGE,
    payload: {
      deadline
    }
  }),
  formTaskSummaryChange: taskSummary => ({
    type: formEditorConstants.FORM_TASK_SUMMARY_CHANGE,
    payload: {
      taskSummary
    }
  }),
  formHeaderImageChange: headerImage => ({
    type: formEditorConstants.FORM_HEADER_IMAGE_CHANGE,
    payload: {
      headerImage
    }
  }),
  formConfirmationTextChange: confirmationText => ({
    type: formEditorConstants.FORM_CONFIRMATION_TEXT_CHANGE,
    payload: {
      confirmationText
    }
  }),
  formButtonLabelChange: buttonLabel => ({
    type: formEditorConstants.FORM_BUTTON_LABEL_CHANGE,
    payload: {
      buttonLabel
    }
  }),
  formButtonColorChange: buttonColor => ({
    type: formEditorConstants.FORM_BUTTON_COLOR_CHANGE,
    payload: {
      buttonColor
    }
  }),
  formTaskAssigneesChange: assignees => ({
    type: formEditorConstants.FORM_TASK_ASSIGNEES_CHANGE,
    payload: {
      assignees
    }
  }),
  searchUsers: (searchText, callback) => ({
    type: formEditorConstants.SEARCH_FORM_TASK_ASSIGNEES,
    payload: {
      searchText,
      callback
    }
  })
};

export default formEditorActions;
